<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <div id="success-alert" class="alert alert-success alert-dismissible fade show" role="alert">
        <strong id="videoTitle"></strong> <span id="message"> </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div id="error-alert" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span id="error-message"></span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <a class="navbar-brand" [routerLink]="['/home']">
            <h5 class="Ws-subtitle">{{constants.WINDOW_DECLINED_TXT}}</h5>
        </a>
        <div class="menu-item-right">
            <span class="select-container">
                <input type="checkbox" name="" id="select" class="select-checkbox" (click)="onClickSelectAll($event)">
                <label for="select">Select All</label>
            </span>
            <span class="navbar-text justify-content-end">
                <button [disabled]="isDisable" (click)="onClickDeleteAll()" class="button-delete-all">
                    <span *ngIf="isDisable" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                        aria-hidden="true"></span>
                    Delete All Forever</button>
                <button [disabled]="isDisable" (click)="onClickDelete()" class="button-delete">
                    <span *ngIf="isDisable" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                        aria-hidden="true"></span>
                    Delete Forever</button>
            </span>
        </div>
    </nav>
    <div class="row">
        <div style="width: 100%;padding: 10px;" class="col-6">
            <div>
                <img class="video-title" style="width: 50%;" *ngIf="isLoading"
                    src="{{constants.VIDEO_TITLE_SKELTON_IMG}}" alt="">
                <input *ngIf="!isLoading || videos?.length != 0" [disabled]="disableEdit" class="video-title" type="text"
                    value="{{currentVideoTitle}}" placeholder="{{currentVideoTitle}}">
            </div>
            <img class="video-player" *ngIf="isLoading" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <img class="video-player" *ngIf="videos?.length === 0" src="{{constants.PLAYER_SKELTON_IMG}}" alt="">
            <video controls class="video-player" src="{{currentUrl}}"
                *ngIf="!isLoading && videos?.length !== 0"></video>
            <div class="button-container">
            </div>
        </div>
        <div class="col-6  table-responsive">
            <table class="table">
                <tbody>
                    <tr *ngIf="isLoading">
                        <div *ngFor="let item of skeltonArray">
                            <td>
                                <img style="width: 81%;" [src]="item" alt="">
                            </td>
                        </div>
                    </tr>
                    <tr *ngIf="!isLoading">
                        <div *ngIf="videos?.length === 0">
                            <td>
                                <p class="error">List is empty...
                                </p>
                            </td>
                        </div>
                    </tr>
                    <tr id="{{video.videoName}}"
                        *ngFor="let video of videos |filter:videoTitle | paginate: { itemsPerPage: 5, currentPage: p }">
                        <td *ngIf="!isLoading" id="{{video.videoName}}-row">
                            <div class="row">
                                <label class="col-8 table-card" for="{{video.videoName}}-select">
                                    <input type="checkbox" id="{{video.videoName}}-select"
                                        (click)="onclickRow(video, $event)" class="select-checkbox">
                                    <div class="icon-container">
                                        <img *ngIf="video.thumbnail" class="pending-video-icon" src="{{video.thumbnail}}"/>
                                        <video *ngIf="!video.thumbnail" class="pending-video-icon" src="{{video.url}}"></video>
                                    </div>
                                    <div class="pending-video-title" id="pending-video-title">
                                        <h6 id="{{video.videoName}}-title">{{video.videoTitle}}</h6>
                                        <span style="font-size: 14px;">{{video.uploadedOn}}</span>
                                        <span class="approved-video-creator">{{video.creatorName}}</span>
                                    </div>
                                </label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls>
        </div>
    </div>
</div>